import styled from 'styled-components'
import { TextBuilder } from './TextBuilder'
import { useEffect, useState } from 'react'
import agedata from './group_texts.json'

var Text = new TextBuilder()

const DynamicTextFR = ({ group, age }: { group: number; age: number }) => {
  const [displayText, setDisplayText] = useState<(string | JSX.Element)[]>()

  let age_string = age === 18 ? '18-65' : '65+'

  let agegroup = agedata.find((d: any) => {
    return d.age_group === age_string && d.wealth_group === group
  })

  // if (!agegroup) agegroup = agedata[0]
  useEffect(() => {
    Text.clear()
      .add(
        <b>
          Avec votre combinaison de revenu et de fortune, vous faites partie{' '}
        </b>
      )
      .decide_by_index(group, [
        <b>des 10% de la population les moins riches de Suisse.</b>,
        <>
          <b>des personnes menacées de pauvreté. </b>En Suisse, 10% de la
          population est moins riche que vous, 75% est plus aisé.
        </>,
        <>
          <b>
            du bas de l'échelle. En Suisse, 25% des personnes sont moins riches
            que vous et 50% appartiennent à un groupe de personnes plus aisées.
          </b>
        </>,
        <>
          <b>
            de la classe moyenne. En Suisse, 50% de la population est moins
            aisée que vous, 25% fait partie d'un groupe de richesse supérieur.
          </b>
        </>,
        <>
          <b>
            du haut de l'échelle. En Suisse, 75% des personnes sont moins riches
            que vous et 10% appartiennent à un groupe de personnes plus aisées.
          </b>
        </>,
        <>
          <b>
            vous faites partie des 10% de la population les plus aisés de
            Suisse.
          </b>
        </>,
      ])
      .add(' ')
      .decide_by_index(
        group,
        age === 18
          ? [
              <>
                Les personnes de votre catégorie ont un revenu moyen allant
                jusqu'à {formatNumber(agegroup?.maxlohn1 || 0)} Fr. par an et
                pas de fortune ou, en cas de revenu très bas, une fortune allant
                jusqu'à {formatNumber(agegroup?.maxvermoegen2 || 0)} Fr.
              </>,
              <>
                Les personnes de votre catégorie avec une fortune allant jusqu'à{' '}
                {formatNumber(formatNumber(agegroup?.vermoegen1 || 0) || 0)} Fr.
                ont un revenu annuel entre{' '}
                {formatNumber(formatNumber(agegroup?.minlohn1 || 0) || 0)} et{' '}
                {formatNumber(formatNumber(agegroup?.maxlohn1 || 0) || 0)} Fr.
                Sans revenu, votre fortune se situerait entre{' '}
                {formatNumber(agegroup?.minvermoegen2 || 0)} et{' '}
                {formatNumber(agegroup?.maxvermoegen2 || 0)} Fr.
              </>,
              <>
                Les personnes de votre catégorie ont une fortune de{' '}
                {formatNumber(agegroup?.vermoegen1 || 0)} Fr. par exemple et un
                revenu compris entre {formatNumber(agegroup?.minlohn1 || 0)} et{' '}
                {formatNumber(agegroup?.maxlohn1 || 0)} Fr. par année.
              </>,
              <>
                Les personnes de votre catégorie ont une fortune de{' '}
                {formatNumber(agegroup?.vermoegen1 || 0)} Fr. par exemple et un
                revenu de plus de {formatNumber(agegroup?.minlohn1 || 0)} Fr.
                par an. Avec un revenu annuel de{' '}
                {formatNumber(agegroup?.lohn2 || 0)} Fr. une fortune de{' '}
                {formatNumber(agegroup?.minvermoegen2 || 0)} Fr. suffit déjà
                pour appartenir à ce groupe.
              </>,
              <>
                Les personnes de votre catégorie ont une fortune de{' '}
                {formatNumber(agegroup?.vermoegen1 || 0)} Fr. et un revenu
                annuel de plus de {formatNumber(agegroup?.minlohn1 || 0)} Fr.
                par exemple. Avec un revenu annuel de{' '}
                {formatNumber(agegroup?.lohn2 || 0)} francs, une fortune de{' '}
                {formatNumber(agegroup?.minvermoegen2 || 0)} Fr. suffit déjà
                pour appartenir à ce groupe.
              </>,
              <>
                Les personnes de votre catégorie ont une fortune de{' '}
                {formatNumber(agegroup?.vermoegen1 || 0)}
                Fr. pour un revenu annuel de{' '}
                {formatNumber(agegroup?.minlohn1 || 0)} Fr. - ou, pour un revenu
                de {formatNumber(agegroup?.lohn2 || 0)} Fr. une fortune
                supérieure à {formatNumber(agegroup?.minvermoegen2 || 0)} Fr.
              </>,
            ]
          : [
              <>
                Dans votre tranche d'âge, le classement dépend davantage de la
                fortune. Les personnes de votre groupe, avec un revenu annuel
                très bas, ont une fortune allant jusqu'à{' '}
                {formatNumber(agegroup?.maxvermoegen2 || 0)} francs.
              </>,
              <>
                Dans votre tranche d'âge, le classement dépend davantage de la
                fortune. Les personnes de votre groupe ont, pour une fortune de{' '}
                {formatNumber(agegroup?.vermoegen1 || 0)} Fr. un revenu annuel
                compris entre {formatNumber(agegroup?.minlohn1 || 0)} et{' '}
                {formatNumber(agegroup?.maxlohn1 || 0)} francs. Sans revenu, votre
                fortune se situerait entre{' '}
                {formatNumber(agegroup?.minvermoegen2 || 0)} et{' '}
                {formatNumber(agegroup?.maxvermoegen2 || 0)} francs.
              </>,
              <>
                Dans votre tranche d'âge, le classement dépend davantage de la
                fortune. Les personnes de votre groupe ont par exemple, pour un
                revenu de {formatNumber(agegroup?.lohn2 || 0)} francs, une
                fortune comprise entre{' '}
                {formatNumber(agegroup?.minvermoegen2 || 0)} et{' '}
                {formatNumber(agegroup?.maxvermoegen2 || 0)} francs.
              </>,
              <>
                Dans votre tranche d'âge, le classement dépend davantage de la
                fortune. Les personnes de votre groupe ont par exemple, pour un
                revenu de {formatNumber(agegroup?.lohn2 || 0)} francs, une
                fortune comprise entre{' '}
                {formatNumber(agegroup?.minvermoegen2 || 0)} et{' '}
                {formatNumber(agegroup?.maxvermoegen2 || 0)} francs.
              </>,
              <>
                Dans votre tranche d'âge, le classement dépend davantage de la
                fortune. Les personnes de votre groupe ont par exemple, pour un
                revenu de {formatNumber(agegroup?.lohn2 || 0)} francs, une
                fortune comprise entre{' '}
                {formatNumber(agegroup?.minvermoegen2 || 0)} et{' '}
                {formatNumber(agegroup?.maxvermoegen2 || 0)} francs.
              </>,
              <>
                Dans votre tranche d'âge, le classement dépend davantage de la
                fortune. Les personnes de votre groupe ont pour la plupart une
                fortune supérieure à{' '}
                {formatNumber(agegroup?.minvermoegen2 || 0)} Fr.
              </>,
            ]
      )

    setDisplayText(Text.get())
  }, [group, age])

  return <DynamicTextContainer>{displayText}</DynamicTextContainer>
}
const DynamicTextContainer = styled.div`
  margin-bottom: 60px;
  background-color: var(--yellow-main);
  color: var(--brandblue-main);

  padding: 20px;
  border-radius: 10px;
  font-size: 18px;
  line-height: 1.6em;
  @media screen and (max-width: 711px) {
    font-size: 15px;
  }
`

export default DynamicTextFR
const formatNumber = (num: string | number | undefined) => {
  if (!num && num !== 0) return ''
  return +num < 10000 ? num : num.toLocaleString('de-CH')
}
